import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'md-access-denied',
  templateUrl: 'access-denied.component.html',
  styleUrls: ['access-denied.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessDeniedComponent {}
